import { Grid, TextField as MuiTextField } from '@material-ui/core'
import styled, { css } from 'styled-components'

import InlineSpinner from '../../../../../../InlineSpinner'

export const SearchInputContainerGrid = styled(Grid)`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  border-radius: 8px;
  cursor: text;
  border: 1px solid transparent;

  &:focus {
    border: 1px solid ${({ theme }) => theme.colors.brandBlue.dark100};
  }
`

export const IconContainerGrid = styled(Grid)`
  .icon {
    color: ${({ theme }) => theme.colors.coolGray.cool500};
    width: 25px;
    height: 25px;
    margin-left: 16px;
  }
`

export const SearchInput = styled(MuiTextField)`
  width: 100%;
  margin-bottom: 0;

  &.MuiFormControl-root {
    margin-bottom: 0;
  }

  & .MuiFilledInput-root.Mui-focused {
    border-color: transparent;
  }
`

export const SearchLoadIcon = styled(InlineSpinner)`
  margin-top: 6px;
`

export const AutoCompleteContainer = styled.div`
  margin-top: 6px;
  max-height: 420px;
  width: 100%;
  background-color: white;
  box-shadow: 1px 3px 7px 0.5px rgba(11, 11, 11, 0.21);
  overflow-x: hidden;
  overflow-y: scroll;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background-color: ${({ theme }) => theme.colors.neutralGray.neutral100};
  }

  ::-webkit-scrollbar {
    width: 8px;
    background-color: ${({ theme }) => theme.colors.neutralGray.neutral100};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    background-color: ${({ theme }) => theme.colors.neutralGray.neutral600};
  }
`

const suggestItemStyles = css`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.neutralGray.neutral600};
  padding: 0.3125rem 0;
  min-height: 90px;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontFamilies.gothamNarrow};
`

export const SuggestItemList = styled.ul`
  ${suggestItemStyles};
  list-style: none;
  height: 100%;
  max-width: 100%;
`

export const SuggestItemListEntry = styled.li`
  max-height: 190px;
  padding: 5px 0;
  overflow: hidden;
`

export const NoSearchResultsContainer = styled.div`
  ${suggestItemStyles};
  margin-bottom: 0;
  margin-top: 1rem;
  font-size: 1rem;
  line-height: 125%;
  p {
    color: ${({ theme }) => theme.colors.neutralGray.neutral600};
    margin-bottom: 1rem;
  }
`

export const NoSearchResultsSpan = styled.span`
  color: ${({ theme }) => theme.colors.brand.red};
  font-weight: 500;
`

export const NoSearchResultsList = styled.ul`
  list-style-type: disc;
  margin-bottom: 1rem;
  margin-top: 0;
  padding-inline-start: 40px;
  height: 100%;
  max-width: 100%;
  li {
    max-height: 190px;
    padding: 5px 0;
  }
`
